/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useParams } from 'react-router'
import useQueryParams from '../../../../client/js/hooks/useQueryParams'
import PageTitle from '../../../../client/js/components/PageTitle'
import MandateListCard, { MandateListQuery } from '../mandate/MandateListCard'
import { useIntl } from 'react-intl'
import { useMemo } from 'react'
import { Container } from '@mantine/core'
import { getMandateCreateLink } from '../../lib/links/mandateLinks'
import Page from '../../../../client/js/components/Page'
import CustomerBreadcrumb from './CustomerBreadcrumb'
import { useRouteLoaderData } from '../../../../client/js/components/RouteLoaderData'

function CustomerMandateListPage () {
  const intl = useIntl()
  const params = useParams<{ id: string }>()
  const customerId = parseInt(params.id, 10)
  const customer = useRouteLoaderData<Customer>()

  const [searchParams, setSearchParams] = useQueryParams()
  const searchQuery: MandateListQuery = useMemo(() => ({
    ...searchParams,
    customerId: params.id
  }), [params.id, searchParams])

  const title = intl.formatMessage({
    id: 'mandates',
    defaultMessage: 'Mandats'
  })

  return (
    <Page>
      <Container size="xl">
        <PageTitle
          hidden
          title={title}
        />

        <CustomerBreadcrumb
          customer={customer}
          title={title}
        />

        <MandateListCard
          createLink={getMandateCreateLink({ customerId })}
          query={searchQuery}
          onQueryChange={setSearchParams}
        />
      </Container>
    </Page>
  )
}

export default CustomerMandateListPage
